import { useAuth } from '../../context/useAuth'
import { useNls } from '../../nls/nlsProvider'
import { Login } from '../Auth/Login'
import { FamilyEntry } from './FamilyEntry'
import { FamilyStatePage } from './FamilyStatePage'

export const FamilyRoute = () => {
  const { t } = useNls()
  const { currentUser, isAuthLoading, isSessionLocked } = useAuth()

  if (isAuthLoading) {
    return (
      <FamilyStatePage
        body={t('NLSFamilyLoading')}
        ariaLabel={t('NLSFamilyAriaLoading')}
      />
    )
  }

  if (!currentUser) return <Login />
  if (isSessionLocked) return <Login isLocked />

  return <FamilyEntry />
}
